/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminAssociatedContact,
  AdminAssociatedContactAddProfile,
  AdminAssociatedContactDetail,
  AdminV1OrganizationsAssociatedContactsListParams,
  AdminV1OrganizationsAssociatedContactsProfilesListParams,
  PaginatedAdminAssociatedContactList,
  PaginatedAssociatedContactProfileSummaryList,
  PatchedAdminAssociatedContact
} from '.././model';

import adminV1OrganizationsAssociatedContactsListMutator from '../../shared/services/axios-client';
import adminV1OrganizationsAssociatedContactsRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsAssociatedContactsUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsAssociatedContactsPartialUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsAssociatedContactsAddProfileCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsAssociatedContactsProfilesListMutator from '../../shared/services/axios-client';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsAssociatedContactsList = (
    organizationId: number,
    params?: AdminV1OrganizationsAssociatedContactsListParams,
 options?: SecondParameter<typeof adminV1OrganizationsAssociatedContactsListMutator<PaginatedAdminAssociatedContactList>>,) => {
      return adminV1OrganizationsAssociatedContactsListMutator<PaginatedAdminAssociatedContactList>(
      {url: `/api/admin/v1/organizations/${organizationId}/associated_contacts/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsAssociatedContactsRetrieve = (
    organizationId: number,
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsAssociatedContactsRetrieveMutator<AdminAssociatedContactDetail>>,) => {
      return adminV1OrganizationsAssociatedContactsRetrieveMutator<AdminAssociatedContactDetail>(
      {url: `/api/admin/v1/organizations/${organizationId}/associated_contacts/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsAssociatedContactsUpdate = (
    organizationId: number,
    id: number,
    adminAssociatedContact: NonReadonly<AdminAssociatedContact>,
 options?: SecondParameter<typeof adminV1OrganizationsAssociatedContactsUpdateMutator<AdminAssociatedContact>>,) => {
      return adminV1OrganizationsAssociatedContactsUpdateMutator<AdminAssociatedContact>(
      {url: `/api/admin/v1/organizations/${organizationId}/associated_contacts/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminAssociatedContact
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsAssociatedContactsPartialUpdate = (
    organizationId: number,
    id: number,
    patchedAdminAssociatedContact: NonReadonly<PatchedAdminAssociatedContact>,
 options?: SecondParameter<typeof adminV1OrganizationsAssociatedContactsPartialUpdateMutator<AdminAssociatedContact>>,) => {
      return adminV1OrganizationsAssociatedContactsPartialUpdateMutator<AdminAssociatedContact>(
      {url: `/api/admin/v1/organizations/${organizationId}/associated_contacts/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminAssociatedContact
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsAssociatedContactsAddProfileCreate = (
    organizationId: number,
    id: number,
    adminAssociatedContactAddProfile: AdminAssociatedContactAddProfile,
 options?: SecondParameter<typeof adminV1OrganizationsAssociatedContactsAddProfileCreateMutator<AdminAssociatedContact>>,) => {
      return adminV1OrganizationsAssociatedContactsAddProfileCreateMutator<AdminAssociatedContact>(
      {url: `/api/admin/v1/organizations/${organizationId}/associated_contacts/${id}/add_profile/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminAssociatedContactAddProfile
    },
      options);
    }
  /**
 * Get all profiles associated with this contact
 * @summary Get all profiles associated with this contact
 */
export const adminV1OrganizationsAssociatedContactsProfilesList = (
    organizationId: number,
    id: number,
    params?: AdminV1OrganizationsAssociatedContactsProfilesListParams,
 options?: SecondParameter<typeof adminV1OrganizationsAssociatedContactsProfilesListMutator<PaginatedAssociatedContactProfileSummaryList>>,) => {
      return adminV1OrganizationsAssociatedContactsProfilesListMutator<PaginatedAssociatedContactProfileSummaryList>(
      {url: `/api/admin/v1/organizations/${organizationId}/associated_contacts/${id}/profiles/`, method: 'GET',
        params
    },
      options);
    }
  export type AdminV1OrganizationsAssociatedContactsListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsAssociatedContactsList>>>
export type AdminV1OrganizationsAssociatedContactsRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsAssociatedContactsRetrieve>>>
export type AdminV1OrganizationsAssociatedContactsUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsAssociatedContactsUpdate>>>
export type AdminV1OrganizationsAssociatedContactsPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsAssociatedContactsPartialUpdate>>>
export type AdminV1OrganizationsAssociatedContactsAddProfileCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsAssociatedContactsAddProfileCreate>>>
export type AdminV1OrganizationsAssociatedContactsProfilesListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsAssociatedContactsProfilesList>>>
